const POWER_ON_FUNCTIONAL_ITEMS = new Set([
  "pulse oximeter",
  "penlight",
  "electronic glucose meter",
  "digital thermometer (non-tympanic)"
]);

function normalizeItemName(value: string): string {
  return value.toLowerCase().replace(/\s+/g, " ").trim();
}

export function truckCheckVerificationPrompt(itemName: string | null | undefined): string | null {
  if (!itemName) return null;

  const name = normalizeItemName(itemName);
  if (name === "aed") return "Power on and functional";
  if (name === "portable oxygen cylinder") return "Functional (Crack Test)";
  if (name === "portable suction unit") return "Powers on and has suction";
  if (POWER_ON_FUNCTIONAL_ITEMS.has(name)) return "Power on and functional";

  return null;
}
